<div class="body">
    <app-left-menu></app-left-menu>
    <div class="apps-right">
        <div class="page-container">
            <div class="inner-page-container">
                <div class="white">
                    <div class="page-title">
                        <div class="row">
                            <div class="col-md-5">
                                <h3>View Pre-Quote</h3>
                            </div>
                            <div class="col-md-7 text-right">
                                <div class="action-btn">
                                    <button pButton pRipple label="" icon="las la-plus" title="Add" (click)="GoToCreate($event)"
                                        class="p-button-success p-mr-2"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-container scroll-y">
                        <div class="card">
                            <p-toolbar styleClass="p-mb-4">
                                <ng-template pTemplate="left">
                                    <span class="p-input-icon-left">
                                        <i class="las la-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </ng-template>

                                <ng-template pTemplate="right">
                                    <button type="button" pButton pRipple icon="las la-file-excel"
                                        title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                        tooltipPosition="bottom" (click)="exportExcel()"></button>
                                </ng-template>
                            </p-toolbar>

                            <!-- <p-table #dt [value]="agentListGrid" [scrollable]="true" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']"
                                [style]="{'overflow':'auto!important'}" [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true" scrollHeight="200px"> -->
                                <p-table #dt [value]="PreQuoteListGrid" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]" [columns]="cols"
                                [globalFilterFields]="['customercode','customername','pan','customername','istransporter','companytype','prequotestatus','modifiedby','modifiedon']"
                                [rowHover]="true" dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                 [showCurrentPageReport]="true" [scrollable]="true">
                                 <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:180px">
                                        <col style="width:150px">
                                        <col style="width:300px">
                                        <col style="width:150px">
                                        <col style="width:170px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                    </colgroup>
                                </ng-template> 
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="width:150px;text-align: center;" pSortableColumn="customercode">View <p-sortIcon field="customercode">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="customername" style="width:12%">Customer Name <p-sortIcon field="customername"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="pan">Temp Customersite Name <p-sortIcon field="pan"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="istransporter">GST Number <p-sortIcon field="istransporter"></p-sortIcon>
                                        </th>
                                        
                                        <th pSortableColumn="companytype">Contact Person Name <p-sortIcon field="companytype">
                                            </p-sortIcon>
                                        </th>                                                                       
                                        <th pSortableColumn="billingcycle">Mobile No <p-sortIcon field="billingcycle">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="prequotestatus" style="width:13%">Email Id <p-sortIcon field="prequotestatus"></p-sortIcon>
                                        </th>                                       
                                        <th pSortableColumn="modifiedby">Contract Effective From <p-sortIcon field="modifiedby"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="modifiedon">Credit Limit <p-sortIcon field="modifiedon"></p-sortIcon>
                                        </th>    
                                        <th pSortableColumn="modifiedon">Invoice Credit <p-sortIcon field="modifiedon"></p-sortIcon>
                                        </th> 
                                        <th pSortableColumn="modifiedon">Updated On <p-sortIcon field="modifiedon"></p-sortIcon>
                                        </th> 
                                        <th pSortableColumn="modifiedon">Status <p-sortIcon field="modifiedon"></p-sortIcon>
                                        </th>                                     
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-_DashboardListGrid>
                                    <tr>
                                        <!-- <td>
                                            {{_DashboardListGrid.customercode}}
                                        </td> -->
                                        <td style="text-align: center;">
                                            <button pButton pRipple title="View" icon="las la-eye"
                                                class="p-button p-button p-mr-2" (click)="ViewCustomerSite(_DashboardListGrid)"
                                                >
                                            </button>
                                        </td>
                                        <td>
                                            {{_DashboardListGrid.customername}}
                                        </td>
                                        <td>
                                            {{_DashboardListGrid.customersitename}}
                                        </td>
                                        <td>
                                            {{_DashboardListGrid.gstin}}
                                        </td>
                                        <td>
                                            {{_DashboardListGrid.contactperson}}
                                        </td>
                                        <td>
                                            {{_DashboardListGrid.mobileno}}
                                        </td>
                                        <td>
                                            {{_DashboardListGrid.emailid}}
                                        </td>                                       
                                        <td>
                                            {{_DashboardListGrid.efectivefrom | date:'dd/MM/yyyy'}}
                                        </td>  
                                        <td>
                                            {{_DashboardListGrid.creditlimit}}
                                        </td>  
                                        <td>
                                            {{_DashboardListGrid.invoicecreditdays}}
                                        </td> 
                                        <td>
                                            {{_DashboardListGrid.modifiedon | date:'dd/MM/yyyy'}}
                                        </td> 
                                        <td>
                                            {{_DashboardListGrid.prequotestatus}}
                                        </td>                                                                            
                                    </tr>
                                </ng-template>
                            </p-table>
                            <div class="page-loader" *ngIf="_IsProgressSpinner">
                                <p-progressSpinner strokeWidth="5"></p-progressSpinner>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

